// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1zQ9T","header":"MergedInvoice_header__31BpK"};